module.exports = "https://www.gc-qa.gnp.com.mx/26aaa210d2547b820ef99531980bb9b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-8.jpg
// module id = 956
// module chunks = 0 1